<template>

  <div class="row g-0">
    <div class="col-12 col-lg-10 m-auto py-3">
      <div class="row g-0 ">
        <div class="col-12 m-0 p-0">

          <div class="row justify-content-center">
            <div class="col-12 col-xxl-10 p-5">
              <h2 class="mb-4 px-0 px-lg-5">Uuuups!<br><br>{{ $t('literals.page-not-found') }}<br></h2>
              <localized-link to="/" class="footerLink">{{ $t('literals.back-to-home') }}</localized-link>
              <br><br><br>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
  export default {
    name: "PageNotFound",
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    }
  };
</script>

